"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noteTypes = void 0;
const fontawesome_svg_core_1 = require("@fortawesome/fontawesome-svg-core");
const faCircleInfo_1 = require("@fortawesome/pro-duotone-svg-icons/faCircleInfo");
const faLightbulb_1 = require("@fortawesome/pro-duotone-svg-icons/faLightbulb");
const faMessageExclamation_1 = require("@fortawesome/pro-duotone-svg-icons/faMessageExclamation");
const faOctagonExclamation_1 = require("@fortawesome/pro-duotone-svg-icons/faOctagonExclamation");
const localize_1 = require("@ifixit/localize");
const lit_1 = require("lit");
const choose_js_1 = require("lit/directives/choose.js");
const unsafe_html_js_1 = require("lit/directives/unsafe-html.js");
const declareComponent_1 = require("./declareComponent");
exports.noteTypes = ['note', 'tip', 'important', 'warning', 'caution'];
const noteTypeText = {
    note: (0, localize_1._js)('Note'),
    tip: (0, localize_1._js)('Tip'),
    important: (0, localize_1._js)('Important'),
    warning: (0, localize_1._js)('Warning'),
    caution: (0, localize_1._js)('Caution'),
};
function faIcon(faImportedIcon) {
    const htmls = (0, fontawesome_svg_core_1.icon)(faImportedIcon, {
        attributes: { width: 16, height: 16 },
    }).html;
    return htmls.map(unsafe_html_js_1.unsafeHTML);
}
class WikiNote extends lit_1.LitElement {
    constructor() {
        super();
        this.type = 'note';
    }
    render() {
        return (0, lit_1.html) `
         <div class="note-box ${this.type}">
            <div class="type">
               ${(0, choose_js_1.choose)(this.type, [
            ['tip', () => faIcon(faLightbulb_1.faLightbulb)],
            ['important', () => faIcon(faMessageExclamation_1.faMessageExclamation)],
            ['warning', () => faIcon(faMessageExclamation_1.faMessageExclamation)],
            ['caution', () => faIcon(faOctagonExclamation_1.faOctagonExclamation)],
        ], () => faIcon(faCircleInfo_1.faCircleInfo))}
               ${noteTypeText[this.type]}
            </div>
            <slot></slot>
         </div>
      `;
    }
}
WikiNote.styles = (0, lit_1.css) `
      ${(0, lit_1.unsafeCSS)(fontawesome_svg_core_1.dom.css())}
      :host {
         display: block;
         font: inherit;
         margin-block: 1em;
      }
      ::slotted(*) {
         margin-block: 0 !important;
      }
      .note-box {
         border-left: 4px solid currentColor;
         display: grid;
         gap: 1em;
         padding-block: 0.5em;
         padding-inline: 1em;
      }
      .type {
         color: currentColor;
         display: flex;
         align-items: center;
         text-transform: capitalize;
         font-size: 18px;
         font-weight: 700;
         white-space: normal;
      }
      .type > svg {
         margin-right: 0.5em;
      }
      .note,
      .note-box {
         color: var(--color-blue-500, #3b82f6);
      }
      .tip {
         color: var(--color-green-500, #10b981);
      }
      .important {
         color: var(--color-purple-500, #8b5cf6);
      }
      .warning {
         color: var(--color-yellow-600, #d97706);
      }
      .caution {
         color: var(--color-red-500, #ef4444);
      }
      slot {
         color: var(--color-gray-800, #1f2937);
      }
   `;
WikiNote.properties = { type: { type: String } };
(0, declareComponent_1.declareComponent)('wiki-note', WikiNote);
